import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, ArrowRight } from 'lucide-react';
import { performLogout } from '../redux/authSlice';
import useAxiosAuth from '../hooks/useAxiosAuth';
import logo from '../assets/img/logo-TT2.png';

// The Super Admin experience was split out of this app into the dedicated
// admin portal (Frontend-superadmin-web). A super admin who signs in here —
// or who still has an old session — lands on this notice instead of the old
// /tenants screens, and is signed out so the tenant app never carries a
// platform-owner session.
export default function SuperAdminMoved() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const axiosInstance = useAxiosAuth();

  // Sign the super admin out of THIS app on arrival. The admin portal is
  // where their session belongs now; leaving it live here would let old
  // bookmarks keep half-working.
  useEffect(() => {
    if (localStorage.getItem('isAuthenticated') === 'true') {
      dispatch(performLogout({ axiosInstance }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      data-testid="superadmin-moved-page"
      className="min-h-screen w-full flex items-center justify-center px-4 bg-gradient-to-br from-[#4ABDBD] to-[#3A9B9B]/90"
    >
      <div className="bg-white/95 backdrop-blur-md rounded-2xl sm:rounded-3xl shadow-2xl border border-white/20 max-w-md w-full p-8 flex flex-col items-center gap-4 text-center">
        <img src={logo} alt="Mitra One Care" className="w-16 h-16 object-contain" />
        <div className="w-12 h-12 rounded-full bg-[#E7F5F4] flex items-center justify-center">
          <ShieldCheck className="w-6 h-6 text-[#2D8A8A]" />
        </div>
        <h1 className="text-xl font-bold text-gray-800">Super Admin has moved</h1>
        <p className="text-sm text-gray-600">
          Super Admin has moved to the admin portal. This application now serves
          hospitals and clinics only — please sign in at the Super Admin portal
          instead.
        </p>
        <button
          data-testid="superadmin-moved-back"
          onClick={() => navigate('/login', { replace: true })}
          className="mt-2 inline-flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold text-white bg-gradient-to-r from-[#4ABDBD] to-[#3A9B9B] hover:from-[#4ABDBD]/90 hover:to-[#3A9B9B]/90 shadow-lg transition-all cursor-pointer"
        >
          Back to sign in
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
